import { bootstrapApplication } from '@angular/platform-browser';
import { mergeApplicationConfig } from '@angular/core';
import { fetchSpaClientConfig, showSpaBootFailure } from '@oa/shared-core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { CLIENT_CONFIG, CustomerClientConfig } from './app/client-config';
import { environment } from '@env/environment';

import "@angular/compiler";

// B2C and other environment-specific settings come from the API, so the same build can
// be deployed to beta and production. MSAL can't be created without them, so they load first.
fetchSpaClientConfig<CustomerClientConfig>(
  `${environment.apiConfig.uri}config/spa/customer`
).then(
  (clientConfig) =>
    bootstrapApplication(
      AppComponent,
      mergeApplicationConfig(appConfig, { providers: [{ provide: CLIENT_CONFIG, useValue: clientConfig }] })
    ).catch((err) => console.error(err)),
  (err) => {
    console.error(err);
    showSpaBootFailure();
  }
);
